import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import CarDetailsSection from 'components/pages/proposal/carDetailsSection'
import CustomerSection from 'components/pages/proposal/customerSection'
import NovatedLeaseSection from 'components/pages/proposal/novatedLeaseSection'
import DeductionSection from 'components/pages/proposal/deductionSection'
import ProposalSummarySection from 'components/pages/proposal/proposalSummarySection'
import TakeHomeSection from 'components/pages/proposal/takeHomeSection'
import RfbaSection from 'components/pages/proposal/rfbaSection'
import { fireInteractionCustomEvent, IsVehicleElectric } from 'helpers'
import { createPdf } from 'utils/utilityFunctions'
import zenscroll from 'zenscroll'
import * as S from './pdfElements'
import { SummarySheet } from './summarySheet'
import { PrimaryButton } from '@mmsg/louie'
import { useHistory } from 'react-router-dom'
import { NonGovdisclaimer } from 'components/disclaimers/nonGovdisclaimer'
import withLocation from 'components/withLocation'
import {
  startedPdfDownload,
  finishedPdfDownload,
} from 'actions/downloadPdfAction'

export const PdfView = ({
  type,
  accessToken,
  opportunityId,
  proposalEstimateId,
  dontScroll,
  evRebateApplicable,
  evRebateValue,
  evRebateLink
}) => {
  let dispatch = useDispatch()
  let history = useHistory()
  let url = window.location.href.toLowerCase()

  let isProposal =
    type === 'proposal' || url.indexOf(proposalEstimateId) !== -1 ? true : false

  let proposalEstimate = useSelector(
    (state) => state.individualEstimate.estimate
  )

  const exGst = useSelector((state) =>
    state.user && state.user.employer
      ? state.user.employer.employerGRS.gstExclusiveDeductionsCode.toLowerCase() ===
        'yes'
      : false
  )

  let proposalNumber = useSelector((state) => state.opportunity.proposalNumber)

  const isGov = useSelector((state) => state.individualEstimate.isGov)

  let showRFBA = useSelector(
    (state) =>
      IsVehicleElectric(state.individualEstimate.estimate, true) &&
      state.individualEstimate.estimate.vehicleFBTValue &&
      state.individualEstimate.estimate.vehicleFBTValue < 84916 &&
      state.individualEstimate.estimate.fbtMethod &&
      state.individualEstimate.estimate.fbtMethod.toLowerCase() == 'exempt'
  )

  const isGovProposal = isGov && isProposal

  let nlQuoteNumber = useSelector(
    (state) =>
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.nlQuoteNumber
  )

  nlQuoteNumber = isProposal
    ? 'Proposal_' + nlQuoteNumber
    : 'Estimate_' + nlQuoteNumber
  let dateOfProposalAcceptance = useSelector(
    (state) =>
      state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.acceptedOn
  )

  dateOfProposalAcceptance = isProposal ? dateOfProposalAcceptance : null
  proposalNumber = isProposal ? proposalNumber : null

  let user = useSelector((state) => state.user)

  let payFrequency =
    user && user.employer && user.employer.payFrequency
      ? user.employer.payFrequency
      : ''

  let deductionSectionTitle = `4${isGovProposal ? 'A' : ''}. Your ${
    !isProposal ? 'estimated' : ''
  } total ${payFrequency} deductions`
  let deductionSectionAnnualTitle = `4B. Your ${
    !isProposal ? 'estimated' : ''
  } total annual deductions`

  let takeHomePayTitle = (isGov ? '6' : '5') + '. Your resulting take home pay'
  let rfbaTitle =
    (isGov ? '7' : '6') +
    '. Electric Vehicle FBT Exemption - What you need to know'

  let userEmployer = user && user.employer ? user.employer : null

  let negativeEquityAmount = 0
  let proposalExpiryDate = new Date()

  let isValidDate = (date) => {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
      ? true
      : false
  }

  if (proposalExpiryDate !== null && isValidDate(proposalExpiryDate)) {
    proposalExpiryDate.setDate(proposalExpiryDate.getDate() + 30)
  }

  var novatedLeaseData = {
    proposalEstimate: proposalEstimate,
    negativeEquityAmount: negativeEquityAmount,
  }

  const [disable, setDisable] = useState(false)
  const downloadPdfClicked = () => {
    setDisable(true)
    dispatch(startedPdfDownload())
    zenscroll.toY(0, 500, () => {
      createPdf(nlQuoteNumber, 'pdf', () => {
        setDisable(false)
        dispatch(finishedPdfDownload())
      })
    })

    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'download pdf',
          label: 'download pdf',
        },
      },
    })
  }

  useEffect(() => {
    dontScroll
      ? console.log('')
      : setTimeout(function () {
          zenscroll.toY(0)
        }, 200)
  }, [])

  const afterMarketAccessories = useSelector(
    (state) => state.individualEstimate.afterMarketAccessories
  )

  const carDetailsSectionData = proposalEstimate
    ? {
        ...proposalEstimate.vehicle,
        vehicleType: proposalEstimate.vehicleType,
        vehicleDescription: proposalEstimate.vehicleDescription,
      }
    : {}

  const novatedLeaseSectionData = {
    negativeEquityAmount: negativeEquityAmount,
    downloadingPdf: disable,
    pdf: true,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    compInsuranceProvider: proposalEstimate && proposalEstimate.compInsuranceProvider,
    driveawayPrice: proposalEstimate && proposalEstimate.driveawayPrice,
    evRebateApplicable,
    evRebateValue,
    evRebateLink,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    extendedWarrantyProvider:
      proposalEstimate && proposalEstimate.extendedWarrantyProvider,
    extendedWarrantyTerm:
      proposalEstimate && proposalEstimate.extendedWarrantyTerm,
    financeAmount: proposalEstimate && proposalEstimate.financeAmount,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    gstCreditClaimable: proposalEstimate && proposalEstimate.gstCreditClaimable,
    kmPerAnnum: proposalEstimate && proposalEstimate.kmPerAnnum,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseResidualAmountIncGST:
      proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    rpcProvider: proposalEstimate && proposalEstimate.rpcProvider,
    vehicle: proposalEstimate && {
      ...proposalEstimate.vehicle,
      vehicleType: proposalEstimate && proposalEstimate.vehicleType,
    },
    productId: proposalEstimate && proposalEstimate.productId,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
  }

  const deductionSectionData = {
    carRepaymentPerAnnumExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumExGST,
    carRepaymentPerAnnumIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerAnnumIncGST,
    carRepaymentPerPayExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayExGST,
    carRepaymentPerPayIncGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayIncGST,
    compInsPerAnnumExGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumExGST,
    compInsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.compInsPerAnnumIncGST,
    compInsPerPayExGST: proposalEstimate && proposalEstimate.compInsPerPayExGST,
    compInsPerPayIncGST:
      proposalEstimate && proposalEstimate.compInsPerPayIncGST,
    compInsurancePremium:
      proposalEstimate && proposalEstimate.compInsurancePremium,
    compInsurancePremiumFinanced:
      proposalEstimate && proposalEstimate.compInsurancePremiumFinanced,
    compInsuranceProvider:
      proposalEstimate && proposalEstimate.compInsuranceProvider,
    erAdminFeePerAnnum: proposalEstimate && proposalEstimate.erAdminFeePerAnnum,
    erAdminFeePerPay: proposalEstimate && proposalEstimate.erAdminFeePerPay,
    erSharePerAnnum: proposalEstimate && proposalEstimate.erSharePerAnnum,
    erSharePerPay: proposalEstimate && proposalEstimate.erSharePerPay,
    extendedWarrantyPremium:
      proposalEstimate && proposalEstimate.extendedWarrantyPremium,
    fbtMethod: proposalEstimate && proposalEstimate.fbtMethod,
    fbtPerAnnum: proposalEstimate && proposalEstimate.fbtPerAnnum,
    fbtPerPay: proposalEstimate && proposalEstimate.fbtPerPay,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    fuelPerAnnumExGST: proposalEstimate && proposalEstimate.fuelPerAnnumExGST,
    fuelPerAnnumIncGST: proposalEstimate && proposalEstimate.fuelPerAnnumIncGST,
    fuelPerPayExGST: proposalEstimate && proposalEstimate.fuelPerPayExGST,
    fuelPerPayIncGST: proposalEstimate && proposalEstimate.fuelPerPayIncGST,
    gapCoverPremium: proposalEstimate && proposalEstimate.gapCoverPremium,
    greenfleetPerAnnum: proposalEstimate && proposalEstimate.greenfleetPerAnnum,
    greenfleetPerPay: proposalEstimate && proposalEstimate.greenfleetPerPay,
    gstOnECMPerAnnum: proposalEstimate && proposalEstimate.gstOnECMPerAnnum,
    gstOnECMPerPay: proposalEstimate && proposalEstimate.gstOnECMPerPay,
    electricityPerPayExGST:
      proposalEstimate && proposalEstimate.electricityPerPayExGST,
    electricityPerPayIncGST:
      proposalEstimate && proposalEstimate.electricityPerPayIncGST,
    incidentalsPerAnnumExGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumExGST,
    incidentalsPerAnnumIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerAnnumIncGST,
    incidentalsPerPayExGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayExGST,
    incidentalsPerPayIncGST:
      proposalEstimate && proposalEstimate.incidentalsPerPayIncGST,
    lcdaPerAnnum: proposalEstimate && proposalEstimate.lcdaPerAnnum,
    lcdaPerPay: proposalEstimate && proposalEstimate.lcdaPerPay,
    leaseProtectionPremium:
      proposalEstimate && proposalEstimate.leaseProtectionPremium,
    leaseTermYears: proposalEstimate && proposalEstimate.leaseTermYears,
    maintenancePerAnnumExGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumExGST,
    maintenancePerAnnumIncGST:
      proposalEstimate && proposalEstimate.maintenancePerAnnumIncGST,
    maintenancePerPayExGST:
      proposalEstimate && proposalEstimate.maintenancePerPayExGST,
    maintenancePerPayIncGST:
      proposalEstimate && proposalEstimate.maintenancePerPayIncGST,
    nlFeePerAnnumExGST: proposalEstimate && proposalEstimate.nlFeePerAnnumExGST,
    nlFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.nlFeePerAnnumIncGST,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    nlFeePerPayIncGST: proposalEstimate && proposalEstimate.nlFeePerPayIncGST,
    noOfTyresBudget: proposalEstimate && proposalEstimate.noOfTyresBudget,
    outOfPocketPerPay: proposalEstimate && proposalEstimate.outOfPocketPerPay,
    regoPerAnnumExGST: proposalEstimate && proposalEstimate.regoPerAnnumExGST,
    regoPerAnnumIncGST: proposalEstimate && proposalEstimate.regoPerAnnumIncGST,
    regoPerPayExGST: proposalEstimate && proposalEstimate.regoPerPayExGST,
    regoPerPayIncGST: proposalEstimate && proposalEstimate.regoPerPayIncGST,
    roadsideAssist: proposalEstimate && proposalEstimate.roadsideAssist,
    roadsidePerAnnumExGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumExGST,
    roadsidePerAnnumIncGST:
      proposalEstimate && proposalEstimate.roadsidePerAnnumIncGST,
    roadsidePerPayExGST:
      proposalEstimate && proposalEstimate.roadsidePerPayExGST,
    roadsidePerPayIncGST:
      proposalEstimate && proposalEstimate.roadsidePerPayIncGST,
    rpcPremium: proposalEstimate && proposalEstimate.rpcPremium,
    spFeePerAnnumExGST: proposalEstimate && proposalEstimate.spFeePerAnnumExGST,
    spFeePerAnnumIncGST:
      proposalEstimate && proposalEstimate.spFeePerAnnumIncGST,
    spFeePerPayExGST: proposalEstimate && proposalEstimate.spFeePerPayExGST,
    spFeePerPayIncGST: proposalEstimate && proposalEstimate.spFeePerPayIncGST,
    taxShare: proposalEstimate && proposalEstimate.taxShare,
    totalChargesPerPayExGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGST,
    totalChargesPerPayExGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayExGSTTaxShare,
    totalChargesPerPayIncGST:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGST,
    totalChargesPerPayIncGSTTaxShare:
      proposalEstimate && proposalEstimate.totalChargesPerPayIncGSTTaxShare,
    totalPackagePerAnnumExGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumExGST,
    totalPackagePerAnnumIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerAnnumIncGST,
    totalPackagePerPayExGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayExGST,
    totalPackagePerPayIncGST:
      proposalEstimate && proposalEstimate.totalPackagePerPayIncGST,
    tyresPerAnnumExGST: proposalEstimate && proposalEstimate.tyresPerAnnumExGST,
    tyresPerAnnumIncGST:
      proposalEstimate && proposalEstimate.tyresPerAnnumIncGST,
    tyresPerPayExGST: proposalEstimate && proposalEstimate.tyresPerPayExGST,
    tyresPerPayIncGST: proposalEstimate && proposalEstimate.tyresPerPayIncGST,
    updatedOn: proposalEstimate && proposalEstimate.updatedOn,
    vehicle: proposalEstimate && proposalEstimate.vehicle,
    erShare: proposalEstimate && proposalEstimate.erShare,
    overTheCapMethod: proposalEstimate && proposalEstimate.overTheCapMethod,
  }

  const proposalSummaryData = {
    employerDisplayInterestRateOnDigitalEstimate: !!(
      userEmployer &&
      userEmployer.employerGRS &&
      userEmployer.employerGRS.displayInterestRateOnDigitalEstimate
    ),
    annualRate: proposalEstimate && proposalEstimate.annualRate,
    carRepaymentPerPayExGST:
      proposalEstimate && proposalEstimate.carRepaymentPerPayExGST,
    financeAmount: proposalEstimate && proposalEstimate.financeAmount,
    leaseResidualAmountIncGST:
      proposalEstimate && proposalEstimate.leaseResidualAmountIncGST,
    nlFeePerPayExGST: proposalEstimate && proposalEstimate.nlFeePerPayExGST,
    residualPCT: proposalEstimate && proposalEstimate.residualPCT,
    totalLeaseRunningCostsPerPayExGST:
      proposalEstimate && proposalEstimate.totalLeaseRunningCostsPerPayExGST,
    vehicleFBTValue: proposalEstimate && proposalEstimate.vehicleFBTValue,
  }

  const proposalSummarySectionCommissionData = {
    brokerage: proposalEstimate && proposalEstimate.brokerage,
    brokeragePerAnnum: proposalEstimate && proposalEstimate.brokeragePerAnnum,
    compInsuranceCommGST:
      proposalEstimate && proposalEstimate.compInsuranceCommGST,
    compInsuranceCommissionExGST:
      proposalEstimate && proposalEstimate.compInsuranceCommissionExGST,
    compInsuranceCommissionPerAnnumIncGST:
      proposalEstimate &&
      proposalEstimate.compInsuranceCommissionPerAnnumIncGST,
    extendedWarrantyCommExGST:
      proposalEstimate && proposalEstimate.extendedWarrantyCommExGST,
    extendedWarrantyCommGST:
      proposalEstimate && proposalEstimate.extendedWarrantyCommGST,
    extendenWarrantyCommissionPerAnnumIncGST:
      proposalEstimate &&
      proposalEstimate.extendenWarrantyCommissionPerAnnumIncGST,
    extendedWarrantyProvider:
      proposalEstimate && proposalEstimate.extendedWarrantyProvider,
    financierEstablishmentFee:
      proposalEstimate && proposalEstimate.financierEstablishmentFee,
    financierEstablishmentFeePerAnnum:
      proposalEstimate && proposalEstimate.financierEstablishmentFeePerAnnum,
    gapCoverCommGST: proposalEstimate && proposalEstimate.gapCoverCommGST,
    gapCoverCommissionExGST:
      proposalEstimate && proposalEstimate.gapCoverCommissionExGST,
    gapCoverCommissionPerAnnumIncGST:
      proposalEstimate && proposalEstimate.gapCoverCommissionPerAnnumIncGST,
    leaseProtectionCommExGST:
      proposalEstimate && proposalEstimate.leaseProtectionCommExGST,
    leaseProtectionCommGST:
      proposalEstimate && proposalEstimate.leaseProtectionCommGST,
    leaseProtectionCommissionPerAnnumIncGST:
      proposalEstimate &&
      proposalEstimate.leaseProtectionCommissionPerAnnumIncGST,
    leaseTerm: proposalEstimate && proposalEstimate.leaseTerm,
    rpcCommGST: proposalEstimate && proposalEstimate.rpcCommGST,
    rpcCommissionExGST: proposalEstimate && proposalEstimate.rpcCommissionExGST,
    rpcCommissionPerAnnumIncGST:
      proposalEstimate && proposalEstimate.rpcCommissionPerAnnumIncGST,
    rpcProvider: proposalEstimate && proposalEstimate.rpcProvider,
    vehicleProcurementFee:
      proposalEstimate && proposalEstimate.vehicle.procurementFee,
  }

  const pdfContent = (isDownloadingPdf) => {
    const isDownloading = isDownloadingPdf || false
    return (
      <div className="review-proposal-page">
        <S.PdfTitle>
          <S.PdfLogo
            src={require(`../../../images/Oly.svg`).default}
          />
          {isProposal && (
            <h2 className="mb-2">Novated Lease proposal details</h2>
          )}
          {!isProposal && (
            <h2 className="mb-2">Novated Lease estimate details</h2>
          )}
        </S.PdfTitle>

        <>
          {user && (
            <CustomerSection
              data={user}
              pdf={true}
              title="1. Your details"
              isProposal={isProposal}
              proposalNumber={proposalNumber}
              dateOfProposalAcceptance={dateOfProposalAcceptance}
              isDownloading={isDownloading}
            ></CustomerSection>
          )}
          <CarDetailsSection
            pdf={true}
            vehicle={carDetailsSectionData}
            title="2. The car details"
            isDownloading={isDownloading}
          />
          <NovatedLeaseSection
            data={novatedLeaseSectionData}
            isProposal={true}
            afterMarketAccessories={afterMarketAccessories}
            title="3. Your novated lease"
          />
          <div className="html2pdf__page-break"></div>
          {proposalEstimate && userEmployer && (
            <DeductionSection
              pdf={true}
              data={deductionSectionData}
              userEmployer={userEmployer}
              title={deductionSectionTitle}
              isDownloading={isDownloading}
              downloadingPdf={disable}
            />
          )}
          {proposalEstimate && userEmployer && isGovProposal && (
            <DeductionSection
              pdf={true}
              data={deductionSectionData}
              userEmployer={userEmployer}
              title={deductionSectionAnnualTitle}
              isAnnual
              isDownloading={isDownloading}
              downloadingPdf={disable}
            />
          )}
          {isGovProposal && proposalEstimate && (
            <ProposalSummarySection
              title="5. Proposal Summary"
              data={proposalSummaryData}
              commissionProps={proposalSummarySectionCommissionData}
              inEstimateDetail={false}
              pdf={true}
            />
          )}
          {isGov && !isProposal && proposalEstimate && (
            <ProposalSummarySection
              title="5. Estimate Summary"
              data={proposalSummaryData}
              commissionProps={proposalSummarySectionCommissionData}
              inEstimateDetail={true}
              pdf={true}
            />
          )}
          <TakeHomeSection
            pdf={true}
            data={proposalEstimate}
            title={takeHomePayTitle}
            isDownloading={isDownloading}
          />

          {showRFBA && (
            <RfbaSection pdf={true} includeContainer={true} title={rfbaTitle} />
          )}

          {isGov && (
            <>
              <div className="html2pdf__page-break"></div>
              <SummarySheet novatedLeaseData={novatedLeaseData} exGst={exGst} />
            </>
          )}
        </>

        <div className="html2pdf__page-break"></div>

        <div className="container-md">
          <Row className="mt-5">
            <Col xs={12}>
              <div style={{ textAlign: 'center' }}>
                <img
                  style={{ height: '45px', marginBottom: '4px' }}
                  src={require(`../../../images/Oly.svg`).default}
                />
              </div>
              <hr
                style={{
                  borderColor: 'rgba(0, 0, 0, 0.2)',
                  borderWidth: 'px',
                  marginTop: '0',
                  marginBottom: '2rem',
                }}
              />
            </Col>
            <Col xs={12}>
                <NonGovdisclaimer />              
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  return proposalEstimate ? (
    <>
      <div
        data-html2canvas-ignore="true"
        style={{
          background: '#CCCCCC',
          position: 'sticky',
          display: 'flex',
          justifyContent: 'flex-end',
          top: 0,
          zIndex: 3,
        }}
      >
        <PrimaryButton
          disabled={disable || !proposalEstimate}
          onClick={downloadPdfClicked}
          className="m-2"
          extendInMob
        >
          Download PDF
        </PrimaryButton>
      </div>
      <div id="pdf">{pdfContent()}</div>
    </>
  ) : (
    <Container>
      <div className="mt-5 mb-5 d-flex justify-content-center">
        <img src="/images/loader.gif" alt="" />
      </div>
    </Container>
  )
}

function mapStateToProps(state, ownProps) {
  const accessToken = state.auth.accessToken
  const opportunityId = state.authentication.opportunityId
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null
  const empGRS = state.user && state.user.employer && state.user.employer.employerGRS

  const evRebateApplicable = empGRS && empGRS.evRebateApplicable
  const evRebateLink = empGRS && empGRS.evRebateLink
  const evRebateValue = empGRS && empGRS.evRebateValue

  return {
    accessToken,
    opportunityId,
    proposalEstimateId,
    evRebateApplicable,
    evRebateValue,
    evRebateLink,
  }
}
export default connect(mapStateToProps)(withLocation(PdfView))
